import axios from 'axios';
const base = `${process.env.REACT_APP_BACKEND_URL}/api/top10`;
export const top10Api = {
  me: () => axios.get(`${base}/me`).then(r => r.data),
  summary: () => axios.get(`${base}/summary`).then(r => r.data),
  location: data => axios.put(`${base}/location`, data, { timeout: 20000 }).then(r => r.data),
  start: proposal_id => axios.post(`${base}/start`, { proposal_id }).then(r => r.data),
  prepare: courseKey => axios.post(`${base}/courses/${encodeURIComponent(courseKey)}/prepare`).then(r => r.data),
  badge: id => axios.get(`${base}/badges/${encodeURIComponent(id)}`).then(r => r.data),
};
export const top10Error = e => typeof e.response?.data?.detail === 'string' ? e.response.data.detail : e.message || 'Please try again.';
export const researchTop10 = async (signal, onEvent) => {
  const token = localStorage.getItem('parseeker_session_token');
  const response = await fetch(`${base}/research`, { method: 'POST', signal, headers: token ? { 'X-Session-Token': token } : {} });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(typeof error.detail === 'string' ? error.detail : 'Research could not start. Please retry.');
  }
  const reader = response.body.getReader(); const decoder = new TextDecoder(); let buffer = ''; let result = false;
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      let boundary;
      while ((boundary = buffer.indexOf('\n\n')) >= 0) {
        const block = buffer.slice(0, boundary); buffer = buffer.slice(boundary + 2);
        if (!block.startsWith('data: ')) continue;
        const event = JSON.parse(block.slice(6));
        if (event.type === 'error') throw new Error(event.message);
        if (event.type === 'result') result = true;
        onEvent(event);
      }
      if (done) break;
    }
    if (!result) throw new Error('Research was interrupted. No challenge was started; please retry.');
  } finally { await reader.cancel().catch(() => {}); }
};